<div>
	<h2 *ngIf='title'>{{title}}</h2>
	<div *ngIf='type === "image" && src' class='image-preview'>
		<img [src]='src'/>
	</div>
	<button *ngIf='canEdit' (click)='openUpload()' mat-flat-button color='accent'>{{uploadLabel | translate}}</button>
</div>